var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: { title: "Claim Record Item Viewer", widthClass: "max-1000" },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c(
              "v-card",
              { staticClass: "pa-3 ma-2 elevation-0" },
              [
                _c(
                  "v-form",
                  { ref: "form1", attrs: { "lazy-validation": "" } },
                  [
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          {
                            attrs: {
                              xs: "12",
                              sm: "6",
                              md: "6",
                              lg: "6",
                              cols: "12",
                            },
                          },
                          [
                            _c("v-text-field", {
                              attrs: { readonly: "", label: "Claim Type:" },
                              model: {
                                value: _vm.ClaimRecordItemData.claim_type_name,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.ClaimRecordItemData,
                                    "claim_type_name",
                                    $$v
                                  )
                                },
                                expression:
                                  "ClaimRecordItemData.claim_type_name",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            attrs: {
                              xs: "12",
                              sm: "6",
                              md: "6",
                              lg: "6",
                              cols: "12",
                            },
                          },
                          [
                            _c("v-text-field", {
                              attrs: { readonly: "", label: "Item Name:" },
                              model: {
                                value: _vm.ClaimRecordItemData.claim_item_name,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.ClaimRecordItemData,
                                    "claim_item_name",
                                    $$v
                                  )
                                },
                                expression:
                                  "ClaimRecordItemData.claim_item_name",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            attrs: {
                              xs: "12",
                              sm: "6",
                              md: "6",
                              lg: "6",
                              cols: "12",
                            },
                          },
                          [
                            _c("v-text-field", {
                              attrs: {
                                readonly: "",
                                label: "Consumption Date:",
                              },
                              model: {
                                value: _vm.ClaimRecordItemData.pay_utc_datetime,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.ClaimRecordItemData,
                                    "pay_utc_datetime",
                                    $$v
                                  )
                                },
                                expression:
                                  "ClaimRecordItemData.pay_utc_datetime",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            attrs: {
                              xs: "12",
                              sm: "6",
                              md: "6",
                              lg: "6",
                              cols: "12",
                            },
                          },
                          [
                            _c("v-text-field", {
                              attrs: { readonly: "", label: "Reason:" },
                              model: {
                                value:
                                  _vm.ClaimRecordItemData.claim_reason_text,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.ClaimRecordItemData,
                                    "claim_reason_text",
                                    $$v
                                  )
                                },
                                expression:
                                  "ClaimRecordItemData.claim_reason_text",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            attrs: {
                              xs: "12",
                              sm: "12",
                              md: "12",
                              lg: "12",
                              cols: "12",
                            },
                          },
                          [
                            _c("v-text-field", {
                              attrs: { readonly: "", label: "Description:" },
                              model: {
                                value:
                                  _vm.ClaimRecordItemData
                                    .claim_item_description,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.ClaimRecordItemData,
                                    "claim_item_description",
                                    $$v
                                  )
                                },
                                expression:
                                  "ClaimRecordItemData.claim_item_description",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            attrs: {
                              xs: "12",
                              sm: "12",
                              md: "12",
                              lg: "12",
                              cols: "12",
                            },
                          },
                          [
                            _c("v-text-field", {
                              attrs: { readonly: "", label: "Remarks:" },
                              model: {
                                value: _vm.ClaimRecordItemData.remarks,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.ClaimRecordItemData,
                                    "remarks",
                                    $$v
                                  )
                                },
                                expression: "ClaimRecordItemData.remarks",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            attrs: {
                              xs: "12",
                              sm: "12",
                              md: "12",
                              lg: "12",
                              cols: "12",
                            },
                          },
                          [
                            _vm._v(" AttachMent: "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "\n                max-width\n                border-solid-grey-1 border-radius-5\n                d-flex\n                justify-start\n              ",
                              },
                              _vm._l(
                                _vm.ClaimRecordItemData.receipt_invoice_url,
                                function (img, index) {
                                  return _c("v-img", {
                                    key: index,
                                    staticClass: "ma-2",
                                    staticStyle: {
                                      width: "100px:height:100px",
                                    },
                                    attrs: {
                                      src: img,
                                      "max-height": "120",
                                      "max-width": "120",
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ]
                        ),
                        _c(
                          "v-col",
                          {
                            attrs: {
                              xs: "12",
                              sm: "12",
                              md: "12",
                              lg: "12",
                              cols: "12",
                            },
                          },
                          [
                            _c("v-text-field", {
                              attrs: { readonly: "", label: "Ref.ID:" },
                              model: {
                                value:
                                  _vm.ClaimRecordItemData.receipt_swift_number,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.ClaimRecordItemData,
                                    "receipt_swift_number",
                                    $$v
                                  )
                                },
                                expression:
                                  "ClaimRecordItemData.receipt_swift_number",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "v-card",
              { staticClass: "ma-2 pa-3 elevation-0" },
              [
                _c(
                  "v-form",
                  { ref: "form", attrs: { "lazy-validation": "" } },
                  [
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          {
                            attrs: {
                              xs: "12",
                              sm: "6",
                              md: "6",
                              lg: "6",
                              cols: "12",
                            },
                          },
                          [
                            _c("v-text-field", {
                              attrs: {
                                readonly: "",
                                label: "Actual Amount:",
                                suffix:
                                  _vm.ClaimRecordItemData
                                    .actual_currency_symbol,
                              },
                              model: {
                                value: _vm.ClaimRecordItemData.actual_amount,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.ClaimRecordItemData,
                                    "actual_amount",
                                    $$v
                                  )
                                },
                                expression: "ClaimRecordItemData.actual_amount",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            attrs: {
                              xs: "12",
                              sm: "6",
                              md: "6",
                              lg: "6",
                              cols: "12",
                            },
                          },
                          [
                            _c("v-text-field", {
                              attrs: {
                                suffix:
                                  _vm.ClaimRecordItemData.claim_currency_symbol,
                                readonly: "",
                                label: "Claim Amount:",
                              },
                              model: {
                                value: _vm.ClaimRecordItemData.claim_amount,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.ClaimRecordItemData,
                                    "claim_amount",
                                    $$v
                                  )
                                },
                                expression: "ClaimRecordItemData.claim_amount",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }